var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/SpinnerSpokes.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from spinner--spokes.svg
 */
export default function SpinnerSpokesIcon(props) {
  return _jsxDEV("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 64 64",
    "data-component": "SpinnerSpokesIcon",
    ...props,
    children: _jsxDEV("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "6",
      children: [_jsxDEV("path", {
        d: "M32 16V4",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: "0;1;.8;.65;.45;.3;.15;0"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 20,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        d: "m43.314 20.686 8.485-8.485",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".15;0;1;.8;.65;.45;.3;.15"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 28,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        d: "M48 32h12",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".3;.15;0;1;.8;.65;.45;.3"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        d: "m43.314 43.314 8.485 8.485",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".45;.3;.15;0;1;.85;.65;.45"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        d: "M32 48v12",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".65;.45;.3;.15;0;1;.8;.65;"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 52,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        d: "m20.686 43.314-8.485 8.485",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: ".8;.65;.45;.3;.15;0;1;.8"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        d: "M16 32H4",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: "1;.85;.6;.45;.3;.15;0;1;"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 68,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        d: "m20.686 20.686-8.485-8.485",
        children: _jsxDEV("animate", {
          attributeName: "stroke-opacity",
          dur: "750ms",
          repeatCount: "indefinite",
          values: "0;1;.8;.65;.45;.3;.15;0"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 76,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=SpinnerSpokes.js.map